import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NewEnvelopeService } from 'src/app/envelope/new-envelope/new-envelope.service';
import { TableSignUser } from '../model/tableSignUser';
import { AnalyticsService } from 'src/app/modules/google-analytics/service/analytics.service';
import { TrackerData } from 'src/app/modules/google-analytics/model/tracker-data.model';
import { AnalyticEventClient } from 'src/app/enum/analytic-event-client.enum';
import * as R from 'ramda';

interface UserDto {
  name: string;
  email: string;
  order: number;
  disabled: boolean;
  userIndex: number;
}

@Component({
  selector: 'app-signatory-order',
  templateUrl: './signatory-order.component.html',
  styleUrls: ['./signatory-order.component.scss']
})
export class SignatoryOrderComponent implements OnInit {

  _elements: Array<UserDto>;
  canSave = false;
  orderChanged = false;
  orderEnabled: boolean;
  orderMax: number;

  @Output() closeModalClick = new EventEmitter();
  @Output() submitModalClick = new EventEmitter();

  constructor(private newEnvelopeService: NewEnvelopeService
    , private translate: TranslateService, private googleAnalyticService: AnalyticsService) {
  }

  ngOnInit() {
    const data = Object.assign(this.newEnvelopeService
      .getModelData(this.newEnvelopeService.getCurrentStep()));

    this.orderEnabled = data.isOrdered;
    this._elements = data.elements.map((element, index) => ({
      name: element.name,
      email: element.mail,
      ssn: element.ssn,
      order: element.order,
      disabled: false,
      userIndex: index,
    }));
    this._elements.sort((a, b) => a.order - b.order);
    this.orderMax = this.maxSignatoryOrder();
  }

  modalClose() {
    this.closeModalClick.emit();
  }

  modalSubmit() {
    this.googleAnalyticService.sendEvent(
          new TrackerData(
            AnalyticEventClient.TK_PT_SIGNER_NEW_ENVELOPE,
            'Signer_NovEnv_OrdenaçãoSignatários',
            this.orderEnabled ? 'Ativo' : 'Inativo'
          )
        );

    const data = Object.assign(this.newEnvelopeService.getModelData(this.newEnvelopeService.getCurrentStep()));
    data.elements = this._elements.map(element => {
      const resultElement = data.elements[element.userIndex];
      resultElement[TableSignUser.propOrder] = element.order;
      return resultElement;
    });
    data.isOrdered = this.orderEnabled;
    this.newEnvelopeService.setModelData(data);
    this.submitModalClick.emit();
  }

  processKeyPress(e) {
    if(e.charCode <= 47){
      return false
    }
  }

  processChange(i, event, element) {

    const regex : RegExp =/^\d*[1-9]\d*$/

    if(!regex.test(event.target.value)){
      event.target.value = '1';
    } else if(event.target.value > this._elements.length) {
      event.target.value = this._elements.length.toString();
    }

    let value = event.target.value;

    let order = parseInt(value || '1');

    this._elements[i].order = order;

    if (!this.verifyOrder()) {
      this.canSave = false;
      this.orderChanged = false;
     return;
    }

    if (order > this.maxSignatoryOrder()) {
      order = this.maxSignatoryOrder();
    }

    this._elements[i][TableSignUser.propOrder] = value;
    this._elements[i] = { ...this._elements[i], order };
    this._elements.sort((a, b) => a.order - b.order);
    this.canSave = true;
    this.orderChanged = true;
    this.orderMax = this.maxSignatoryOrder();
    
  }

  verifyOrder(){
    let maxOrder = Math.max(...this._elements.map(el => el.order), 0);
    
    let isOrdered = true;

    for (var minOrder = 1; minOrder < maxOrder; minOrder++) {
      const existsOrder = this._elements.find(x => x.order == minOrder);
      
      if (!existsOrder) {
        isOrdered = false;
      }
    }
    return isOrdered;
  }

  onChangeEnabled(e) {
    this.orderChanged = e;
    this.canSave = this.verifyOrder();
    this.orderEnabled = this.orderChanged;
  }

  maxSignatoryOrder(): number {
    const order = Math.max(...this._elements.map(el => el.order), 0);
    if (order >= R.length(this._elements)) {
      return R.length(this._elements);
    }
    return order + 1;
  }
}
